
class ForbiddenError extends Error {
}

export default ForbiddenError;
